module.exports = __webpack_public_path__ + "img/r7.e3df3eed.svg";